import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { BzgModalService } from 'bz-genome-angular';
import { EmailSentDialogComponent } from './email-sent-dialog/email-sent-dialog.component';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'account-information',
    templateUrl: 'account-information.component.html',
    styleUrls: ['account-information.component.scss']
})
export class AccountInformationComponent {
    public userName = '';
    public errorSendingEmail = false;

    constructor(private _translateService: TranslateService,
        private _autoLoginClient: AutoLoginClient,
        private _modalService: BzgModalService,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) { }

    ngOnInit() {
        this._autoLoginClient.getProfile()
            .subscribe((response) => {
                this.userName = response && response.username ? response.username : '';
            });
    }

    public changePassword() {
        this._autoLoginClient.sendVerificationCode(this.userName).subscribe((response) => {
            switch (response) {
                case 'SendVerificationCodeSuccessful':
                    this.errorSendingEmail = false;
                    this._modalService.open(EmailSentDialogComponent, {closeOnBackdropClick: false, closeOnRouterNavigation: true});
                    break;
                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION'), 'error');
                        break;
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.MISSING_SMTP_CONFIGURATION'), 'error');
                        break;
                    case 'SendVerificationCodeUserNotFound':
                    case 'SendVerificationCodeUnexpectedError':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR'), 'error');
                        break;
                    default:
                        this._showToastService.showToast(this._i18nService.instant('GLOBAL.GENERIC_ERROR_MSG'), 'error');
                        break;
            }
        });
    }
}
